import { validatePhoneNumberLength } from 'libphonenumber-js';
import { getTranslation } from '../providers/TranslationProvider';

export const getCanonicalPhoneErrorMessage = () => getTranslation({
  translationKey: 'errors.mobile_number.invalid',
  fallback: 'Please enter a valid mobile number',
});

export const getPhoneLengthReason = (values = {}, fieldName = 'phone') => {
  const phoneDigits = (values[fieldName] || '').replace(/\D/g, '');
  if (!phoneDigits || !values.country_code) {
    return null;
  }

  return validatePhoneNumberLength(`+${values.country_code}${phoneDigits}`);
};

export const getPhoneValidationError = (
  values = {},
  { validateIncomplete = false, fieldName = 'phone' } = {}
) => {
  const phoneDigits = (values[fieldName] || '').replace(/\D/g, '');
  if (!phoneDigits) {
    return validateIncomplete ? getCanonicalPhoneErrorMessage() : null;
  }

  const reason = getPhoneLengthReason(values, fieldName);
  if (reason === 'TOO_LONG') {
    return getCanonicalPhoneErrorMessage();
  }
  if (validateIncomplete && (reason === 'TOO_SHORT' || reason === 'INVALID_LENGTH')) {
    return getCanonicalPhoneErrorMessage();
  }

  return null;
};
